import { render, staticRenderFns } from "./VRequestSendToBitrix24Modal.vue?vue&type=template&id=3fb2a1e4"
import script from "./VRequestSendToBitrix24Modal.vue?vue&type=script&lang=js"
export * from "./VRequestSendToBitrix24Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports